module.exports = __webpack_public_path__ + "hero-expertise-left.3kKt_g4z.png";